<template>
    <v-form
        ref="unitTypeTimeSeriesForm"
        v-model="formValid"
        lazy-validation>                    
            <v-layout wrap>
                <v-flex xs12 px-2>                            
                    <v-text-field
                    v-model="selectedTimeSerie.name"                     
                    label="Naam voor datastroom"
                    :rules="[formRules.name]"                         
                    required>
                    </v-text-field>
                </v-flex>

                <v-flex xs12 px-2>                            
                    <v-text-field
                    v-model="selectedTimeSerie.currentStatusName"                     
                    label="Datastroom groepsnaam"
                    :rules="[formRules.currentStatusName]"                         
                    required>
                    </v-text-field>
                </v-flex>                

                <v-flex x12 px-2>                                
                    <v-switch 
                        label="Primaire datastroom (wordt als eerste getoond)"
                        v-model="selectedTimeSerie.isPrimary">
                    </v-switch>                                
                </v-flex>  

                <v-flex xs12 px-2>                            
                    <v-text-field
                    v-model="selectedTimeSerie.eventName"                     
                    label="Event naam"
                    :rules="[formRules.eventName]"                                             
                    required>
                    </v-text-field>
                </v-flex>  

                <v-flex xs12 px-2>                            
                    <v-text-field
                    v-model="selectedTimeSerie.targetFieldName"                     
                    label="Event data veldnaam gebruikt voor berekening"
                    :rules="[formRules.targetFieldName]"                                             
                    required>
                    </v-text-field>
                </v-flex>                
                                 
                <v-flex xs12 md6 px-2>                            
                    <v-select
                        :items="measurementUnits"    
                        item-text="label"
                        item-value="key"                    
                        label="Maat eenheid"
                        v-model="selectedTimeSerie.unitOfMeasure"
                        :rules="[formRules.unitOfMeasure]"                                             
                        required                        
                    ></v-select>
                </v-flex>                                   

                <v-flex xs12 md6 px-2>                            
                    <v-select
                        :items="aggregateModes"    
                        item-text="label"
                        item-value="key"                    
                        label="Type grafiek"
                        v-model="selectedTimeSerie.aggregateMode"
                        :rules="[formRules.aggregateMode]"                                             
                        required                                    
                    ></v-select>
                </v-flex>                               

                <v-flex row xs12 wrap>                  
                    <v-layout >
                        <v-btn
                            @click="cancel"                          
                            color=""> 
                            Annuleren
                        </v-btn>                                                                                                         
                        <v-spacer></v-spacer>                                                                          
                        <v-btn                                                
                            color="success"
                            @click="save">
                            Opslaan
                        </v-btn>                        
                    </v-layout>                                                                    
                </v-flex>  
            </v-layout>                                     
        </v-form>    
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'    
    export default {
        data() {
            return {
                formValid:true,
                formRules:{
                    name:(value) => {return (value) ? true : "Veld verplicht"},
                    currentStatusName:(value) => {return (value) ? true : "Veld verplicht"},
                    eventName:(value) => {return (value) ? true : "Veld verplicht"},                    
                    targetFieldName:(value) => {return (value) ? true : "Veld verplicht"},
                    unitOfMeasure:(value) => {return (value) ? true : "Veld verplicht"},
                    aggregateMode:(value) => {return (value) ? true : "Veld verplicht"}
                },              
                selectedTimeSerie: {id:0, name:"",eventName:"",targetFieldName:"",aggregateMode:"",unitOfMeasure:"",currentStatusName:"",isPrimary:"",unitTypeId:this.unitTypeId}
            }
        },
        computed: {
            ...mapGetters({
                aggregateModes: types.HD_AGGREGATE_MODES,
                measurementUnits: types.HD_MEASUREMENT_UNITS
            })
        },
        props: {
            timeSerie: {
                type: Object
            },
            unitTypeId:{                
                required:true
            }
        },
        methods:{
            save(){
                if (this.$refs.unitTypeTimeSeriesForm.validate()) {                    
                
                    let save = this.selectedTimeSerie
                    save.isPrimary = this.selectedTimeSerie.isPrimary ? true:false
                    
                    this.$store.dispatch(types.SAVE_UNIT_TYPE_TIMESERIE, {data:save} ).then((e) => {                                                                   
                        this.selectedTimeSerie.id = e.id
                        this.$emit('saved', this.selectedTimeSerie)
                    });                     
                }
            },
            cancel(){
                this.$emit('cancelClicked')                  
            }
        }, 
        mounted(){
            if(this.timeSerie){
                Object.assign(this.selectedTimeSerie, this.timeSerie)       
            }
        }
    }
</script>

<style scoped>

</style>